import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

export interface CreateResourceRequest {
  type: 'PROJECT';
  value: string;
}

export const portalApiUrl = environment.portalApiUrl;

@Injectable({
  providedIn: 'root',
})
export class ResourcesApiService {
  constructor(private http: HttpClient) {}

  createResource(ifs: string) {
    const request: CreateResourceRequest = {
      type: 'PROJECT',
      value: ifs.trim(),
    };

    return this.http.post(`${portalApiUrl}/resources`, request);
  }
}
